import React, { FunctionComponent } from 'react';
import { CiShell } from '../../features/ci-demo/CiShell';

export const Home: FunctionComponent = () => <CiShell />;
